import { render, staticRenderFns } from "./UpdatesPerAgent.vue?vue&type=template&id=0a2885c8&scoped=true&"
import script from "./UpdatesPerAgent.vue?vue&type=script&lang=js&"
export * from "./UpdatesPerAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2885c8",
  null
  
)

export default component.exports